/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchRequestDto } from './SearchRequestDto';
import {
    SearchRequestDtoFromJSON,
    SearchRequestDtoFromJSONTyped,
    SearchRequestDtoToJSON,
    SearchRequestDtoToJSONTyped,
} from './SearchRequestDto';
import type { CategoryOverviewDtoSortingRequestDto } from './CategoryOverviewDtoSortingRequestDto';
import {
    CategoryOverviewDtoSortingRequestDtoFromJSON,
    CategoryOverviewDtoSortingRequestDtoFromJSONTyped,
    CategoryOverviewDtoSortingRequestDtoToJSON,
    CategoryOverviewDtoSortingRequestDtoToJSONTyped,
} from './CategoryOverviewDtoSortingRequestDto';
import type { FilterRequestDto } from './FilterRequestDto';
import {
    FilterRequestDtoFromJSON,
    FilterRequestDtoFromJSONTyped,
    FilterRequestDtoToJSON,
    FilterRequestDtoToJSONTyped,
} from './FilterRequestDto';
import type { PagingRequestDto } from './PagingRequestDto';
import {
    PagingRequestDtoFromJSON,
    PagingRequestDtoFromJSONTyped,
    PagingRequestDtoToJSON,
    PagingRequestDtoToJSONTyped,
} from './PagingRequestDto';

/**
 * 
 * @export
 * @interface CategoryOverviewDtoFilterSortSearchPagedRequestDto
 */
export interface CategoryOverviewDtoFilterSortSearchPagedRequestDto {
    /**
     * 
     * @type {FilterRequestDto}
     * @memberof CategoryOverviewDtoFilterSortSearchPagedRequestDto
     */
    filters?: FilterRequestDto;
    /**
     * 
     * @type {SearchRequestDto}
     * @memberof CategoryOverviewDtoFilterSortSearchPagedRequestDto
     */
    search?: SearchRequestDto;
    /**
     * 
     * @type {PagingRequestDto}
     * @memberof CategoryOverviewDtoFilterSortSearchPagedRequestDto
     */
    paging?: PagingRequestDto;
    /**
     * 
     * @type {CategoryOverviewDtoSortingRequestDto}
     * @memberof CategoryOverviewDtoFilterSortSearchPagedRequestDto
     */
    sorting?: CategoryOverviewDtoSortingRequestDto;
}

/**
 * Check if a given object implements the CategoryOverviewDtoFilterSortSearchPagedRequestDto interface.
 */
export function instanceOfCategoryOverviewDtoFilterSortSearchPagedRequestDto(value: object): value is CategoryOverviewDtoFilterSortSearchPagedRequestDto {
    return true;
}

export function CategoryOverviewDtoFilterSortSearchPagedRequestDtoFromJSON(json: any): CategoryOverviewDtoFilterSortSearchPagedRequestDto {
    return CategoryOverviewDtoFilterSortSearchPagedRequestDtoFromJSONTyped(json, false);
}

export function CategoryOverviewDtoFilterSortSearchPagedRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryOverviewDtoFilterSortSearchPagedRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'filters': json['filters'] == null ? undefined : FilterRequestDtoFromJSON(json['filters']),
        'search': json['search'] == null ? undefined : SearchRequestDtoFromJSON(json['search']),
        'paging': json['paging'] == null ? undefined : PagingRequestDtoFromJSON(json['paging']),
        'sorting': json['sorting'] == null ? undefined : CategoryOverviewDtoSortingRequestDtoFromJSON(json['sorting']),
    };
}

export function CategoryOverviewDtoFilterSortSearchPagedRequestDtoToJSON(json: any): CategoryOverviewDtoFilterSortSearchPagedRequestDto {
    return CategoryOverviewDtoFilterSortSearchPagedRequestDtoToJSONTyped(json, false);
}

export function CategoryOverviewDtoFilterSortSearchPagedRequestDtoToJSONTyped(value?: CategoryOverviewDtoFilterSortSearchPagedRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filters': FilterRequestDtoToJSON(value['filters']),
        'search': SearchRequestDtoToJSON(value['search']),
        'paging': PagingRequestDtoToJSON(value['paging']),
        'sorting': CategoryOverviewDtoSortingRequestDtoToJSON(value['sorting']),
    };
}

